import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../../interfaces/user';
import { StateService } from '../../services/state.service';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-navbar',
    imports: [],
    templateUrl: './navbar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './navbar.component.scss'
})
export class NavbarComponent implements OnDestroy {
  user = {} as User;
  currentRoute: string = '';
  subRoute: Subscription
  constructor(
    private router : Router,
    private state: StateService,
    private auth: AuthService
  ){
    this.user = JSON.parse(sessionStorage.getItem('user')??'{}');
    this.subRoute = this.state.currentRoute.subscribe(route => {
      this.currentRoute = route; 
    });
  }
  ngOnDestroy(): void {
    this.subRoute.unsubscribe();
  }

  navTo(path: string){
    this.router.navigate([path]);
  }

  signout() {
    this.auth.logout();
  }
}
